import styled from 'styled-components';
import BaseTransactionDetails from '../../common/TransactionDetalis';

export const Container = styled.div`
  background-color: #bec3ca;
  min-height: calc(100vh - 48px - 2rem);
  padding-bottom: 1px;
`;

export const ConfigNav = styled.div`
  .ant-tabs-top > .ant-tabs-nav {
    margin: 0px;
    background-color: rgba(255, 255, 255, 0.8);
    margin-top: 1px;

    &::before {
      border: none;
    }
  }
  .ant-tabs-nav-list {
    margin-left: 32px;
    margin-right: 8px;
  }

  .ant-tabs-tab {
    padding: 9px;
  }

  .ant-tabs-tabpane {
    padding: 30px;
  }
`;

export const TransactionDetails = styled(BaseTransactionDetails)`
  padding: 10px 20px 20px;
`;

export const NavPanel = styled.div`
  background-color: white;
  padding-left: 24px;
  padding-bottom: 20px;
`;

export const BreadcrumbWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

// ------------------------------------Customer Information ------------------------------

export default {
  plrtb: { padding: '1em 1em' }
};

export const CardView = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 14px 8px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  font-size: 14px;

  header {
    padding: 1em 1em;
  }

  .contant {
    padding: 0 0.9em;
    display: flex;
    gap: 2%;
    flex-wrap: wrap;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;

    p {
      color: #748aa1;
      margin: 0px;
      padding: 2px;
      width: 49%;
    }

    span {
      font-weight: 400;
      line-height: 22px;
      color: #000;
      width: 49%;
    }

    .riskTablet {
      color: #fff;
      padding: 0.2em 1em;
      border-radius: 1em;
      background: red;
      font-size: 11px;
      margin-left: 16px;
    }
  }
`;
//-----------------------------------------------------------------------------------------

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
`;
